export enum AnswerState {
  Default = 'default',
  Answered = 'answered',
  Checked = 'checked',
  UnChecked = 'unchecked',
}
